import { useState, useEffect } from 'react';
import { Route, Routes, Link, useLocation } from 'react-router-dom';
import style from '../assets/css/ListMenu.module.css'; 
import { FaUser, FaKey, FaBars, FaCode } from "react-icons/fa";
import { FaUnlockKeyhole, FaMoneyBill1Wave, FaRegCircleUser } from "react-icons/fa6";
import { BiLogOutCircle } from "react-icons/bi";
import { message } from 'antd';
import ProtectedRoute from '../components/ProtectedRoute';

import Cliente from './pages/Cliente';
import Licenca from './pages/Licenca';
import Senha from './pages/Recover';
import Pagamento from './pages/Pagamentos';
import Parceiro from './pages/Parceiro';
import Bugs from './pages/Bugs';

function Menu() {
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const location = useLocation();
    const user = JSON.parse(localStorage.getItem('user'));

    const toggleMenu = () => {
        if (window.innerWidth <= 991) {
            setMobileMenuOpen(!mobileMenuOpen);
        } else {
            setIsCollapsed(!isCollapsed);
        }
    };

    // Fechar menu ao clicar num link no mobile
    const handleNavClick = () => {
        if (window.innerWidth <= 991) {
            setMobileMenuOpen(false);
        }
    };

    const logout = async () => {
        try {
            localStorage.removeItem('user');
            message.success('Sessão terminada com sucesso');
            window.location.href = '/';
        } catch (error) {
            message.error('Erro ao realizar logout: ' + error.message);
        }
    };

    // Fechar menu mobile ao redimensionar
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 991) {
                setMobileMenuOpen(false);
            }
        };
        
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const isActive = (path) => {
        return location.pathname.includes(path);
    };

    return (
        <div className={`${style.dashboard} ${isCollapsed ? style.collapsed : ''}`}>

            {/* Overlay escuro ao abrir menu no mobile */}
            {mobileMenuOpen && (
                <div className={style.overlay} onClick={() => setMobileMenuOpen(false)} />
            )}

            <div className={`${style.dashboard_nav} ${isCollapsed ? style.collapsed_nav : ''} ${mobileMenuOpen ? style.mobile_open : ''}`}>
                <nav className={style.dashboard_nav_list}>
                    <Link 
                        to="/clientes" 
                        onClick={handleNavClick}
                        className={`${style.dashboard_nav_item} ${isActive('/clientes') ? style.active : ''}`}
                    >
                        <FaUser className={style.icon} /> 
                        <span>Clientes</span>
                    </Link>

                    <Link 
                        to="/licencas" 
                        onClick={handleNavClick}
                        className={`${style.dashboard_nav_item} ${isActive('/licencas') ? style.active : ''}`}
                    >
                        <FaKey className={style.icon} /> 
                        <span>Licenças</span>
                    </Link>

                    <Link 
                        to="/senhas" 
                        onClick={handleNavClick}
                        className={`${style.dashboard_nav_item} ${isActive('/senhas') ? style.active : ''}`}
                    >
                        <FaUnlockKeyhole className={style.icon} /> 
                        <span>Senhas</span>
                    </Link>

                    <Link 
                        to="/bugs" 
                        onClick={handleNavClick}
                        className={`${style.dashboard_nav_item} ${isActive('/bugs') ? style.active : ''}`}
                    >
                        <FaCode className={style.icon} /> 
                        <span>Bugs</span>
                    </Link>

                    {(user?.id === 1 || user?.id === 2) && (
                        <Link 
                            to="/pagamentos" 
                            onClick={handleNavClick}
                            className={`${style.dashboard_nav_item} ${isActive('/pagamentos') ? style.active : ''}`}
                        >
                            <FaMoneyBill1Wave className={style.icon} /> 
                            <span>Pagamentos</span>
                        </Link>
                    )}

                    {(user?.id === 1 || user?.id === 2) && (
                        <Link 
                            to="/parceiros" 
                            onClick={handleNavClick}
                            className={`${style.dashboard_nav_item} ${isActive('/parceiros') ? style.active : ''}`}
                        >
                            <FaRegCircleUser className={style.icon} /> 
                            <span>Parceiros</span>
                        </Link>
                    )}

                    <Link to="#" className={style.dashboard_nav_item} onClick={logout}>
                        <BiLogOutCircle className={style.icon} /> 
                        <span>Sair</span>
                    </Link>
                </nav>
            </div>

            <div className={style.dashboard_app}>
                <header className={style.dashboard_toolbar}>
                    <a href="#!" className={style.menu_toggle} onClick={toggleMenu}>
                        <FaBars className={style.icon_barr}/>
                    </a>
                </header>
              
                <main>
                    <Routes>
                        <Route path="/clientes" element={<ProtectedRoute><Cliente /></ProtectedRoute>} />
                        <Route path="/licencas" element={<ProtectedRoute><Licenca /></ProtectedRoute>} />
                        <Route path="/senhas" element={<ProtectedRoute><Senha /></ProtectedRoute>} />
                        <Route path="/pagamentos" element={<ProtectedRoute><Pagamento /></ProtectedRoute>} />
                        <Route path="/parceiros" element={<ProtectedRoute><Parceiro /></ProtectedRoute>} />
                        <Route path="/bugs" element={<ProtectedRoute><Bugs /></ProtectedRoute>} />
                    </Routes>
                </main>
            </div>
        </div>
    );
}

export default Menu;